import {
  Currency,
  InvoiceType,
  VIP,
  CompletedAnalyseStatus,
  CompletedAnalyseStatusCascader,
  AnalysisCompleteStatus,
  AnalysesingStatus,
  Sky3EndStatus,
  Sky3EndTileStatus,
  Sky3RunningTileStatus,
  ProductRunningTileStatus,
  ProductEndTileStatus,
  rebuildTileStatus,
  RebuildRunStatus,
  RebuildEndStatus,
  PreHandleStatus,
  sky3RunningStatus,
  CompletedTaskStatus,
  RenderingTaskStatus,
  ProductTaskStatus,
  RechargeStatus,
  PayMethod,
  GetWay,
  GiftWay,
  EngineType,
  CouponType,
  StudentStatus,
  MemberType,
  FileType,
  AuditStatus,
  RegisterBuildStatus,
  PayStatus,
  AuditDay,
  AuthTypeList,
  ProductEndTaskStatus,
  PublishTaskStatus,
  RenderToLeaseStatus,
  StopCate,
  DoneCate,
  StopTypes,
  RechargeChannels,
  VIPNational,
} from '../constants'
import _ from 'lodash'

// 推广链接地址
export const RENDERBUS_URL = `https://${window.location.host.startsWith('admin.') ? 'task' : 'task-pre'}.renderbus.com/sso/register?key=`
export const FOXRENDERFARM_URL = `https://${window.location.host.startsWith('admin.') ? 'task' : 'task-pre'}.foxrenderfarm.com/sso/signup?key=`
export const DAYAN_URL = `https://${window.location.host.startsWith('admin.') ? 'task' : 'task-pre'}.dayancloud.com/sso/register?key=`
export const AVICA_URL = `https://${window.location.host.startsWith('admin.') ? 'task' : 'task-pre'}.avicacloud.com/sso/signup?key=`

export const IS_DAYANCLOUD = window.location.host.includes('dayancloud') || window.location.host.includes('avicacloud')
export const IS_RENDERBUS = window.location.host.includes('renderbus')
// 分享链接地址
export const SHARE_LINK_FOXRENDERFARM_URL = `https://${window.location.host === 'admin.renderbus.com' ? 'task' : 'task-pre'}.foxrenderfarm.com/sso/signup?`

// 禅道登录入口
export const ZENTAO_URL = `http://10.51.96.119/zentao/user-login.html`
// 禅道测试bug链接
export const ZENTAO_BUG_BROWSE_URL = `http://10.51.96.119/zentao/bug-browse-29.html`

const VIPList = Object.values(VIP)
const VIPNationalList = Object.values(VIPNational)
const completedAnalyseStatusList = Object.values(CompletedAnalyseStatus)
const CompletedAnalyseStatusCascaderList = Object.values(CompletedAnalyseStatusCascader).map(item => {
  if (_.isObject(item)) {
    return Object.values(item)
  } else {
    return item
  }
})
const AnalysisCompleteStatusList = Object.values(AnalysisCompleteStatus)
const analysesingStatusList = Object.values(AnalysesingStatus)
const sky3EndStatusList = Object.values(Sky3EndStatus)
const sky3EndTileStatusList = Object.values(Sky3EndTileStatus)
const sky3RunningTileStatusList = Object.values(Sky3RunningTileStatus)
const productRunningTileStatusList = Object.values(ProductRunningTileStatus)
const productEndTileStatusList = Object.values(ProductEndTileStatus)
const rebuildTileStatusList = Object.values(rebuildTileStatus)
const sky3RunningStatusList = Object.values(sky3RunningStatus)
const rebuildRunStatusList = Object.values(RebuildRunStatus)
const rebuildEndStatusList = Object.values(RebuildEndStatus)
const preHandleStatusList = Object.values(PreHandleStatus)
const completedTaskStatusList = Object.values(CompletedTaskStatus)
const renderingTaskStatusList = Object.values(RenderingTaskStatus)
const productTaskStatusList = Object.values(ProductTaskStatus)
const rechargeStatusList = Object.values(RechargeStatus)
const currencyList = Object.values(Currency)
const payMethodList = Object.values(PayMethod)
const rechargeChannelsList = Object.values(RechargeChannels)
const fileTypeList = Object.values(FileType)
const auditStatusList = Object.values(AuditStatus)
const registerBuildStatusList = Object.values(RegisterBuildStatus)
const payStatusList = Object.values(PayStatus)
const auditDayList = Object.values(AuditDay)
const getWayList = Object.values(GetWay)
const giftWayList = Object.values(GiftWay)
const invoiceTypeList = Object.values(InvoiceType)
const engineTypeList = Object.values(EngineType)
const couponTypeList = Object.values(CouponType)
const studentStatusList = Object.values(StudentStatus)
const memberTypeList = Object.values(MemberType)
const authTypeList = Object.values(AuthTypeList)
const productEndTaskStatusList = Object.values(ProductEndTaskStatus)
const publishTaskStatusList = Object.values(PublishTaskStatus)
const renderToLeaseStatus = Object.values(RenderToLeaseStatus)
const stopCate = Object.values(StopCate)
const doneCate = Object.values(DoneCate)
const stopTypes = Object.values(StopTypes)

export const urlSet = [
  'admin.renderbus.com',
  'admintest.renderbus.com',
  'admin.foxrenderfarm.com',
  'admintest.foxrenderfarm.com',
  'admin.dayancloud.com',
  'admin-pre.dayancloud.com',
  'admin.avicacloud.com',
  'admin-pre.avicacloud.com',
]

export const filterList = {
  VIPList,
  VIPNationalList,
  completedAnalyseStatusList,
  CompletedAnalyseStatusCascaderList,
  AnalysisCompleteStatusList,
  productRunningTileStatusList,
  productEndTileStatusList,
  rebuildTileStatusList,
  sky3RunningTileStatusList,
  sky3EndStatusList,
  sky3EndTileStatusList,
  analysesingStatusList,
  rebuildRunStatusList,
  rebuildEndStatusList,
  preHandleStatusList,
  completedTaskStatusList,
  sky3RunningStatusList,
  renderingTaskStatusList,
  productTaskStatusList,
  rechargeStatusList,
  currencyList,
  payMethodList,
  rechargeChannelsList,
  getWayList,
  giftWayList,
  invoiceTypeList,
  engineTypeList,
  couponTypeList,
  studentStatusList,
  memberTypeList,
  fileTypeList,
  auditStatusList,
  registerBuildStatusList,
  payStatusList,
  auditDayList,
  authTypeList,
  productEndTaskStatusList,
  publishTaskStatusList,
  renderToLeaseStatus,
  stopCate,
  doneCate,
  stopTypes,
}

export const filterColumn = {
  'sky3Running': ['orderNos', 'adminTagName', 'taskId', 'userName', 'userId', 'projectName', 'submitTime', 'taskStatus', 'restart', 'sky3Fee', 'tasklevel', 'node', 'property', 'requirement', 'constraints', 'group', 'startTime', 'endTime', 'munuJobOverTime', 'hadDelData', 'log', 'remark'],
  'analyseRunning': ['orderNos', 'adminTagName', 'taskId', 'analMunuId', 'userName', 'submitTime', 'fileName', 'status', 'restart', 'level', 'node', 'property', 'requirement', 'constraints', 'group', 'salesman', 'channel', 'startTime', 'endTime', 'munuTaskOverTime', 'log'],
  'rebuildRunning': ['orderNos', 'adminTagName', 'taskId', 'userName', 'userId', 'projectName', 'submitTime', 'status', 'restart', 'level', 'node', 'property', 'requirement', 'constraints', 'group', 'channel', 'startTime', 'endTime', 'taskOverTime', 'log', 'remark'],
  'analyseEnd': ['orderNos', 'adminTagName', 'taskId', 'userName', 'submitTime', 'fileName', 'status', 'restart', 'level', 'node', 'property', 'requirement', 'constraints', 'group', 'salesman', 'channel', 'startTime', 'endTime', 'munuTaskOverTime', 'log'],
  'sky3End': ['orderNos', 'adminTagName', 'taskId', 'userName', 'userId', 'projectName', 'submitDate', 'taskStatus', 'restart', 'sky3Fee', 'taskLevel', 'node', 'property', 'requirement', 'constraints', 'group', 'startTime', 'completedTime', 'munuJobOverTime', 'hadDelData', 'log', 'remark'],
  // 预估完成时间：恢复时在 renderRunning 数组 startTime 之后加回 'estimateTime'
  // （帧详情侧同步放开 frameView/fieldDict.js 里 estimateSeconds 那一行）
  'renderRunning': ['orderNos', 'adminTagName', 'taskId', 'userName', 'fileName', 'frames', 'layerName', 'renderCamera', 'task_status', 'start', 'waiting_count', 'complete', 'abandon', 'failed', 'wait', 'munu_restart', 're_render', 'gpuNum', 'submitTime', 'startTime', 'accountConsume', 'task_level', 'node_num', 'editTaskId', 'cloneParentId', 'property', 'requirement', 'constraints', 'group', 'preTaskId', 'preState', 'task_user_level', 'overTime', 'munuJobOverTime', 'salesman', 'channel', 'projectName', 'remark', 'userRemark', 'label', 'additionalFee', 'software_config', 'plugin_config'],
  'productRunning': ['orderNos', 'adminTagName', 'taskId', 'userName', 'userId', 'prj', 'tile', 'task_status', 'start', 'complete', 'abandon', 'failed', 'wait', 'restart', 'submitTime', 'startTime', 'productFee', 'task_level', 'node_num', 'property', 'requirement', 'constraints', 'group', 'munuJobOverTime', 'salesman', 'remark'],
  'renderCompleted': ['orderNos', 'adminTagName', 'taskId', 'userName', 'fileName', 'frames', 'layerName', 'renderCamera', 'submitTime', 'startTime', 'endTime', 'status', 'complete', 'abandon', 'failed', 'wait', 'munu_restart', 're_render', 'gpuNum', 'accountConsume', 'taskLevel', 'taskLimit', 'editTaskId', 'cloneParentId', 'property', 'requirement', 'constraints', 'group', 'preTaskId', 'preState', 'task_user_level', 'overTime', 'munuJobOverTime', 'salesman', 'channel', 'projectName', 'remark', 'userRemark', 'label', 'additionalFee', 'stopReason', 'software_config', 'plugin_config'],
  'userList': ['customer_id', 'login_name', 'uuid', 'ip', 'phone', 'email', 'user_tag', 'city', 'login_IP', 'login_city', 'level', 'accountType', 'balance', 'credit', 'desktopCoupon', 'coupon', 'firstRechargeAmount', 'totalRechargeAmount', 'agency', 'company', 'isZombie', 'salesman', 'pc', 'td', 'invite_register_type', 'source_type', 'registerType', 'recently_login', 'register_date', 'offlineRegisterSource', 'registerSource', 'offlineRegisterSourceFlag', 'copyrightRegisterSource', 'remark', 'area', 'operation', 'authStatus', 'isDeleted', 'registerProductLine', 'loginProductLine', 'register_inviter', 'register_inviteLinkPromoters', 'registerPlatform', 'loggedPlatform', 'isFirstReCharge', 'isFirstSubmit'],
  'userListPermission': ['customer_id', 'login_name', 'uuid', 'ip', 'phone', 'email', 'city', 'accountType', 'balance', 'credit', 'coupon', 'agency', 'company', 'isZombie', 'salesman', 'pc', 'td', 'user_tag', 'recently_login', 'register_date', 'offlineRegisterSource', 'offlineRegisterSourceFlag', 'copyrightRegisterSource', 'remark', 'area', 'operation', 'authStatus', 'isDeleted', 'registerProductLine', 'loginProductLine', 'inviter', 'registerPlatform', 'loggedPlatform'],
  'consumeDetailList': ['user_ID', 'primary_account', 'sub_account', 'compay_name', 'platform_job_ID', 'platform', 'consumption_type', 'scene_name', 'project', 'render_frame', 'frame_total', 'consumption_time', 'start_detail_time', 'end_detail_time', 'balance_consumption', 'render_coupon_consumption', 'salesman', 'from', 'remark'],
  'nodeList': ['node_id', 'node_name', 'status', 'IP', 'MAC', 'SN', 'property', 'require', 'group', 'real_type', 'real_core_count', 'vr_core', 'real_core', 'memory', 'system_property', 'model', 'running_time', 'stop_time', 'complete_task', 'error_task', 'running_task', 'group_match', 'duration', 'failure_rate', 'remark', 'mirror_limit', 'operate'],
  'softwareCharge': ['software_or_plugin', 'status', 'buyer', 'docking_people', 'seller', 'pay_type', 'purchase_quantity', 'charge', 'currency', 'coupon_start_time', 'end_time', 'server_ip', 'server_ip_password', 'mac_address', 'official_website', 'account', 'password', 'email', 'script_col_remark'],
  'storageManagement': ['name', 'type', 'BID', 'dns', 'path', 'mount_point', 'file_system_type', 'important_level', 'important_assignRate', 'automatic_allocation', 'command', 'storage_business_type', 'open_status', 'remarks'],
  'performance': ['id', 'origin_id', 'type', 'area', 'achievement_country', 'saleman', 'user_id', 'user_name', 'real_name', 'level', 'cpu_price', 'gpu_price', 'recharge_amount', 'currency', 'qingyun_coupon', 'amount', 'receivable_money', 'receipt_status', 'split', 'saleman_comfirm', 'saleman_comfirm_time', 'head_comfirm', 'head_comfirm_time', 'finance_comfirm', 'comfirm_remark', 'company', 'pay_company', 'proxy', 'industry_type', 'software', 'client_type', 'country', 'city', 'rayvision_num', 'pay_status', 'third_num', 'pay_type', 'date', 'recharge_remark', 'invoice_remark', 'registerSourceFlag', 'userType', 'businessType'],
  'billOverviewList': ['consume_date', 'user_ID', 'username_placeholder', 'bill_account_type', 'compay_name', 'fee_type', 'node_type', 'currency', 'pay_amount', 'cash_amount', 'fee_amount', 'render_amount', 'qinyun_amount', 'vocher_amount'],
  'desktopBillOverviewList': ['consume_date', 'user_ID', 'username_placeholder', 'bill_account_type', 'compay_name', 'fee_type', 'node_type', 'currency', 'pay_amount', 'desktop_fee_amount'],
  'billQuantityDetails': ['date', 'fee_type', 'deduction_account_id', 'organizationStructure', 'producer', 'charge_from', 'enterprise_company_name', 'project', 'worker_id', 'scene_name', 'frame_total', 'platform', 'soft_name', 'start_detail_time', 'gpu_model', 'gpu_number', 'consumption_memory', 'project_rendered_time', 'salesman', 'currency', 'fee_amount', 'render_amount', 'qinyun_amount', 'vocher_amount', 'submitUserName', 'userName', 'layerName', 'renderCamera', 'framesRange', 'averageDuration', 'resolution'],
  'billRenderMembers': ['date', 'fee_type', 'ordering', 'user_ID', 'memberUserName', 'charge_from', 'enterprise_company_name', 'pay_way', 'salesman', 'member_type', 'pay_time', 'storage_expired_date', 'cash_amount'],
  'billDesktopCoupon': ['date', 'username', 'user_ID', 'desktopId', 'enterprise_company_name', 'platform', 'fee_type', 'project_rendered_time', 'node_type', 'node_count', 'desktop_fee', 'salesman'],
  'rebuildEnd': ['orderNos', 'adminTagName', 'taskId', 'userName', 'userId', 'submitTime', 'fileName', 'status', 'restart', 'level', 'node', 'property', 'requirement', 'constraints', 'group', 'channel', 'startTime', 'endTime', 'munuTaskOverTime', 'hadDelData', 'log', 'restartLog', 'remark'],
  'productEnd': ['orderNos', 'adminTagName', 'taskId', 'userName', 'frames', 'status', 'submitTime', 'startTime', 'endTime', 'complete', 'abandon', 'failed', 'wait', 'restart', 'produce_cost', 'taskLevel', 'taskLimit', 'property', 'requirement', 'constraints', 'group', 'munuJobOverTime', 'salesman', 'remark'],
  'publish': ['publishId', 'publishJobId', 'userName', 'userName', 'userId', 'publishName', 'nodeName', 'startTime', 'completedTime', 'status', 'duration', 'unitPrice', 'consume', 'remark', 'operate'],
  'lineConfigWeb': ['engine_config', 'line_name', 'zone', 'platform_name', 'transmission', 'type', 'default_line', 'support_user_id', 'not_support_user_id', 'line_remark', 'operate'],
  'lineConfigAnimation': ['engine_config', 'line_name', 'support_user_id', 'not_support_user_id', 'server_name', 'zone', 'port_name', 'ssl_port_name', 'proxy_port_name', 'server_operator', 'zabbix_address', 'hostGroupName', 'hostName', 'traffic_threshold', 'CPU_threshold', 'priority', 'current_cpu_load', 'current_traffic', 'type', 'line_remark', 'operate'],
  'userData': [
    'submitTime',
    'platform',
    'cgId',
    'channel',
    'taskId',
    'userName',
    'userId',
    'businessType',
    'accountType',
    'country',
    'areaId',
    'isZombie',
    'isFirstReCharge',
    'sceneName',
    'framesRange',
    'startTime',
    'endTime',
    'registerTime',
    'taskFistStatus',
    'taskLastStatus',
    'remark',
  ],
  'submitAnalysis': [
    'submitTime',
    'platform',
    'channel',
    'cgName',
    'taskId',
    'taskStatus',
    'userId',
    'userName',
    'businessType',
    'accountType',
    'lever',
    'areaName',
    'country',
    'isZombie',
    'enabled',
    'isDeleted',
    'registerDate',
    'sourceUrl',
    'sourceName',
  ],
  'frameList': [
    'frameBlock',
    'frameIndex',
    'progress',
    'status',
    'feeAmount',
    'couponFee',
    'additional_charges_balance',
    'additional_charges_coupon',
    'render_price',
    'nodeName',
    'model',
    'frameRam',
    'average_cpu',
    'average_gpu',
    'peak_ram',
    'history_avg_gpu',
    'history_avg_cpu',
    'history_high_memory',
    'render_progress',
    'useTime',
    'render_start_time',
    'render_end_time',
    'task_start_time',
    'task_end_time',
    'deduction_times',
    'time_consume',
    'log',
    'frame_completion_progress',
    'render_log',
  ],
}

/**
 *
 * @param filterColumn
 * @param falseKeys
 * 防止 falseKeys 冲突，配合 initFilterColumnByNamespace 使用
 * @param falseKeyIgnorePages
 * @returns {*}
 */
export const dealArr = (filterColumn, falseKeys = {}, { falseKeyIgnorePages = [] }) => {
  // console.log('falseKeyIgnorePages', falseKeyIgnorePages)
  Object.keys(filterColumn).forEach(value => {
    const isIgnorePage = falseKeyIgnorePages.includes(value)

    let temp = {}
    filterColumn[value].forEach(item => {
      if (isIgnorePage) {
        temp[item] = true
        return
      }

      if (falseKeys[item]) {
        temp[item] = false
      } else {
        temp[item] = true
      }
    })
    filterColumn[value] = temp
  })

  storageColumnData(filterColumn)
  return filterColumn
}

const storageColumnData = (filterColumn) => {
  if (localStorage.getItem('columnData')) {
    const columnLocalData = JSON.parse(localStorage.getItem('columnData'))
    for (let key in columnLocalData) {
      if (filterColumn[key]) {
        Object.assign(filterColumn[key], columnLocalData[key])
      } else {
        console.warn(`localStorage 中存在的 key "${key}" 在当前代码中不存在，已跳过`, columnLocalData[key])
      }
    }
  }
  localStorage.setItem('columnData', JSON.stringify(filterColumn))
}

export function initFilterColumnByNamespace(filterColumn, ns, defaultUncheckedColumn) {
  const filterColumnObj = filterColumn[ns]
  Object.keys(filterColumnObj).forEach(column => {
    filterColumnObj[column] = !defaultUncheckedColumn[column]
  })
  storageColumnData(filterColumn)

  return filterColumn
}
